import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { push } from "connected-react-router";

import Modal from "../../ui/Modals/ModalWindow";
import Spinner from "../../ui/Spinner/Spinner";
import RequireAuth from "../../layout/HOC/require-auth";
import "./MessageInfo.scss";

import { getMessageInfoAsync, deleteMessageAsync } from "../../../redux/actions/messageInfo";
import { openDeleteMessageModal, closeDeleteMessageModal } from "../../../redux/actions/ui";
import { getMsgTypeText } from "../../../methods";

const mapStateToProps = state => ({
  ...state.messageInfo,
  deleteMessageModal: state.ui.deleteMessageModal,
});

const mapDispatchToProps = dispatch => ({
  onGoBack: () => dispatch(push('/messages')),
  getMessageInfo: msgId => dispatch(getMessageInfoAsync(msgId)),
  onEditMessage: msgId => dispatch(push(`/edit-message/${msgId}`)),
  onDeleteMessage: (status, msgId) => dispatch(deleteMessageAsync(status, msgId)),
  openDeleteModal: () => dispatch(openDeleteMessageModal()),
  closeDeleteModal: () => dispatch(closeDeleteMessageModal()),
});

class MessageInfo extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    message: PropTypes.object.isRequired,
    deleteMessageModal: PropTypes.object.isRequired,
    onGoBack: PropTypes.func.isRequired,
    onEditMessage: PropTypes.func.isRequired,
    getMessageInfo: PropTypes.func.isRequired,
    onDeleteMessage: PropTypes.func.isRequired,
    openDeleteModal: PropTypes.func.isRequired,
    closeDeleteModal: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { getMessageInfo } = this.props;
    const msgId= this.props.match.params.msgId;
    getMessageInfo(msgId);
  }

  //Распарсивание строки в html
  /*
  createInnerHtml = () => {
    const { message } = this.props;
    return { __html: message.message };
  }
  */

  render() {
    const {
      ready,
      loading,
      message,
      onGoBack,
      onEditMessage,
      onDeleteMessage,
      deleteMessageModal,
      openDeleteModal,
      closeDeleteModal,
    } = this.props;

    return (
      <div className="page-wrapper">
        <Modal
          heading="Вы уверены, что хотите удалить сообщение?"
          confirmText="Отмена"
          cancelText="Удалить"
          modal={deleteMessageModal}
          onSubmit={() => closeDeleteModal()}
          onCancel={() => onDeleteMessage(message.id)}
        />
        {ready ? (
          <React.Fragment>
            <div className="page-header">
              <button type="button" className="btn btn-back" onClick={() => onGoBack()}>
                <i aria-hidden="true" className="back-icon icon" />
                <span>Назад</span>
              </button>
            </div>
          
            <div className="page-content forms message-info">
              <div className="poll-header">
                <div className="poll-btns">
                  <button
                    type="button"
                    className="btn btn-green edit-size"
                    onClick={() => onEditMessage(message.id)}
                  >
                    Редактировать
                  </button>
                  <button
                    type="button"
                    className="btn btn-red del-size"
                    onClick={() => openDeleteModal()}
                  >
                    Удалить
                  </button>
                </div>
                <div className="msg-type">{getMsgTypeText(message.type)}</div>
              </div>
              {/* Заголовок сообщения */}
              <div className="title-wrap">
                <h1 className="page-title">{message.title}</h1>
              </div>

              {/* Текст сообщения */}
              {/*<div className="message-text" dangerouslySetInnerHTML={this.createInnerHtml()} />*/}
              <div className="message-text">{message.message}</div>

              {/* Роли, которым доступно сообщение */}
              <div className="content-info">
                {(message.role.findIndex(role => role === 'consultant') !== -1) ? 
                  (<div className="content-for consultants">Для консультантов</div>)
                : false}
                {(message.role.findIndex(role => role === 'client') !== -1) ? 
                  (<div className="content-for clients">Для клиентов</div>)
                : false}
              </div>
            </div>
          </React.Fragment>
        ) : false}
        {loading ? (<Spinner />) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(MessageInfo));
